export default __webpack_public_path__ + "static/media/blog-img3.6bb7942c.png";